import React from 'react';
import OmniHistoriesMessageBox from './OmniHistoriesMessageBox';
import { TabChatManagementKeys, useOmniHistoriesLeadManageContext } from 'contexts';
import { Button, Spin, Typography } from 'antd';
import { AIContactEvaluationOption } from 'utils';
import Avatar from 'components/common/avatar/Avatar';
import { LeftIcon } from 'assets';
import { twMerge } from 'tailwind-merge';
import { messages } from 'messages';
import { TypographyWaitingTime } from 'components/chat-management';
import { useFindOneContactSentimentByChat } from 'hooks';

type Props = {};
const OmniChannelLeadChatHistoriesChat: React.FC<Props> = () => {
  const { tab, chatSession: chat, chatHistory, chatOngoing, setChatHistory } = useOmniHistoriesLeadManageContext();
  const hasBack = tab === TabChatManagementKeys.HISTORY;
  const chatSession =
    tab === TabChatManagementKeys.HISTORY ? chatHistory : tab === TabChatManagementKeys.ONGOING ? chatOngoing : chat;

  const { contactSentiment, isLoadingContactSentiment } = useFindOneContactSentimentByChat(
    {
      chatId: chatSession?.chatId!
    },
    {
      skip: !chatSession?.chatId
    }
  );

  const optionEvaluation = contactSentiment?.sentiment ? AIContactEvaluationOption[contactSentiment.sentiment] : null;

  return (
    <div className='flex h-full flex-col gap-0'>
      <div
        className={twMerge(
          'flex h-16 w-full shrink-0 items-center border-b border-l px-4',
          hasBack ? '' : 'justify-center'
        )}
      >
        {hasBack ? (
          <div className='flex items-center gap-4'>
            <Button shape='circle' icon={<LeftIcon />} onClick={() => setChatHistory(undefined)} />
            <div className='flex flex-col gap-1'>
              <Typography.Text ellipsis className='max-w-full font-semibold'>
                {chatSession?.chat?.customerName}
              </Typography.Text>
              <Typography.Text className='text-sm capitalize text-colorTextPlaceholder'>{`Kênh ${chatSession?.chat?.source}`}</Typography.Text>
            </div>
          </div>
        ) : (
          <>
            <div className='absolute left-5'>
              <Spin spinning={isLoadingContactSentiment}>{optionEvaluation?.icon(35)}</Spin>
            </div>
            <div className='flex flex-col items-center'>
              <Typography.Text ellipsis className='mb-0.5 max-w-full text-sm font-semibold'>
                {chatSession?.chat?.customerName}
              </Typography.Text>
              {tab === TabChatManagementKeys.ASSIGN ? (
                <TypographyWaitingTime
                  time={chatSession?.createdAt}
                  type='secondary'
                  className='text-sm group-hover:text-white'
                  thresholds={[
                    { limit: 4 * 60, color: '#FF9500' },
                    { limit: 5 * 60, color: '#D1131D' }
                  ]}
                  prefix={messages.waiting}
                ></TypographyWaitingTime>
              ) : (
                <Typography.Text className='text-sm capitalize text-colorTextPlaceholder'>{`Kênh ${chatSession?.chat?.source}`}</Typography.Text>
              )}
            </div>
            <div className='absolute right-5'>
              <Avatar
                key={chatSession?.chatSessionId}
                size={40}
                src={chatSession?.chat?.customerAvatar}
                name={chatSession?.chat?.customerName}
              />
            </div>
          </>
        )}
      </div>

      {chatSession ? (
        <div className='flex h-[calc(100vh-242px)] flex-col bg-secondaryColor1'>
          <OmniHistoriesMessageBox />
        </div>
      ) : (
        <Spin spinning />
      )}
    </div>
  );
};
export default OmniChannelLeadChatHistoriesChat;
